import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import GenericSigManager from '../../components/settings/generic-sig/generic-sig-manager';
import { resolveActingDoctorId } from '../../utils/common-funtions/common';

const GenericSigSettingsTab = () => {
    const { user, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
    // assistants configure the doctor they are working for
    const doctorId = resolveActingDoctorId({ user, selectedRole, selectedDoctor });

    const [count, setCount] = useState(0);

    return (
        <div className="my-profile-layout prescription-settings-page">
            <div className="basic-info profile-panel prescription-settings-panel mb-2 groups-settings generic-sig-settings">
                <div className="profile-panel__toolbar">
                    <div>
                        <h2 className="profile-panel__title">Generic SIG</h2>
                        <p className="profile-panel__subtitle">
                            SIGs per generic, learned from what you prescribe (you can also add your own). When you pick a medicine from the medicine list, the SIG form opens with the matching SIG filled in when it is safe, and your other SIGs for that generic listed to choose from.
                        </p>
                    </div>
                    {count > 0 && (
                        <span className="groups-settings__count">{count}</span>
                    )}
                </div>

                <GenericSigManager doctorId={doctorId} onCountChange={setCount} />
            </div>
        </div>
    );
};

export default GenericSigSettingsTab;
